import { render, staticRenderFns } from "./NewsEdit.vue?vue&type=template&id=dbc93920"
import script from "./NewsEdit.js?vue&type=script&lang=js&external"
export * from "./NewsEdit.js?vue&type=script&lang=js&external"
import style0 from "./NewsEdit.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports